
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/[slug]",
      function () {
        return require("private-next-pages/members/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/[slug]"])
      });
    }
  